import React, { useState, useEffect, useRef } from 'react';
import './VendorMasterForm.css'
import { Alert } from '@mui/material';
import { State, City } from "country-state-city";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Helmet } from 'react-helmet-async';
import * as XLSX from 'xlsx';
import vendorInfo1 from '../../../../Assets/vendorInfo1.jpg'
import vendorInfo2 from '../../../../Assets/vendorInfo2.jpg'
import Switch from '@mui/material/Switch';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import vendorsInfo from '../../../../Assets/vendorsInfo.xlsx';
import { IconButton } from '@mui/material';
import Admin from '../../AdminHome/SideBar/Admin';

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 15,
    height: 15,
    margin: 1.7,
  },
}));

// Columns the backend bulk-import controller actually reads from each excel row.
// Used only for the client-side preview/sanity-check, not for validation enforcement.
const EXPECTED_EXCEL_COLUMNS = [
  'vendorName', 'vendorType', 'address', 'district', 'pincode',
  'vendorPhone', 'contactPerson', 'contactPersonNum', 'contactPersonNum2',
  'state', 'remark'
];

const VendorMasterForm = () => {
  const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [isLoadingStates, setIsLoadingStates] = useState(true);
  const [isLoadingCities, setIsLoadingCities] = useState(true);
  const [showBankForm, setShowBankForm] = useState(false);
  const [recipientName, setRecipientName] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [singleVendor, setSingleVendor] = useState(true)
  const [isZoomed, setIsZoomed] = useState(false);
  const [isZoomed1, setIsZoomed1] = useState(false);
  const [location, setLocation] = useState(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [toInputBox, setToInputBox] = useState(false)

  // --- Bulk excel preview + import result state ---
  const [excelPreview, setExcelPreview] = useState(null); // { headers, rows, totalRows, missingColumns }
  const [excelPreviewError, setExcelPreviewError] = useState('');
  const [importResult, setImportResult] = useState(null); // { successCount, failureCount, failures }

  const handleSwitchChange = (event) => {
    setSingleVendor(event.target.checked);
    // reset bulk-mode transient state when switching modes
    setExcelPreview(null);
    setExcelPreviewError('');
    setImportResult(null);
  };

  const handleSwitchInputBox = (event) => {
    setToInputBox(!toInputBox)
  };

  const [bankDetails, setBankDetails] = useState({
    bankName: '',
    bankAccount: '',
    ifscCode: '',
    branchName: ''
  });
  const [upiDetails, setUpiDetails] = useState({
    mobileNumber: '',
    upiId: ''
  });
  const [errors, setErrors] = useState({
    recipientName: '',
    paymentMethod: '',
    bankDetails: '',
    upiDetails: ''
  });

  useEffect(() => {
    loadStates();
    if (token === "" || userId === "") {
      navigate("/");
    }
  }, [token, userId, navigate]);

  const loadStates = () => {
    setIsLoadingStates(true);
    try {
      const allStates = State.getStatesOfCountry("IN");
      setStates(Array.isArray(allStates) ? allStates : []);
    } catch (error) {
      console.error('Error loading states:', error);
      setStates([]);
    } finally {
      setIsLoadingStates(false);
    }
  }

  const loadCities = (stateCode) => {
    setIsLoadingCities(true);
    try {
      const allCities = City.getCitiesOfState("IN", stateCode);
      setCities(Array.isArray(allCities) ? allCities : []);
    } catch (error) {
      console.error('Error loading cities:', error);
      setCities([]);
    } finally {
      setIsLoadingCities(false);
    }
  };

  useEffect(() => {
    if (selectedState) {
      setCities([]);
      loadCities(selectedState);
    } else {
      setCities([]);
    }
  }, [selectedState]);

  const [formData, setFormData] = useState({
    systemDate: today,
    vendorCode: 'SYSTEM GENERATED',
    vendorName: '',
    vendorType: '',
    address: '',
    state: '',
    district: "",
    pincode: '',
    vendorPhone: '',
    email: '',
    contactPerson: '',
    contactPersonNum: "",
    contactPersonNum2: '',
    panNo: "",
    panCard: "",
    adharNo: '',
    adharCard: "",
    rate: "" || "0",
    perHR: "" || '0',
    GSTNo: "",
    GST: "info",
    remark: ""
  });

  const fullAddress = `${formData.address}, ${formData.district},${formData.pincode}, ${formData.state}`;
  const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${encodeURIComponent(fullAddress)}`;

  useEffect(() => {
    const getLonLat = async () => {
      try {
        const response = await axios.get(url);
        const location = response.data[0];
        setLatitude(location.lat);
        setLongitude(location.lon);
        setLocation(` Latitude: ${location.lat}, Longitude: ${location.lon}`);
      } catch (error) {
        // setLocation("An error occurred while fetching the coordinates.");
      }
    }
    getLonLat()
  }, [fullAddress])

  const [otherFormData, setOtherFormData] = useState({
    vendorsInfo: ''
  })

  useEffect(() => {
    if (formData && formData.state) {
      loadCities(formData.state);
    } else {
      setCities([]);
    }
  }, [formData.state]);

  const GSTRef = useRef(null);
  const panRef = useRef(null);
  const adharCardRef = useRef(null);
  const vendorsInfoRef = useRef(null);

  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    const capitalizedValue = value
      .split(' ')
      .map(word => word.toUpperCase())
      .join(' ');

    setBankDetails({ ...bankDetails, [name]: capitalizedValue });
  };

  const handleUpiDetailsChange = (e) => {
    const { name, value } = e.target;
    setUpiDetails({ ...upiDetails, [name]: value });
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      setLocation("Geolocation is not supported by this browser.");
    }
  };

  const showPosition = (position) => {
    const lat = position.coords.latitude;
    const lon = position.coords.longitude;
    setLocation(`Latitude: ${lat}, Longitude: ${lon}`);
    setLatitude(lat);
    setLongitude(lon);
  };

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        setLocation("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        setLocation("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        setLocation("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        setLocation("An unknown error occurred.");
        break;
    }
  };

  const handleLatitudeChange = (e) => {
    setLatitude(e.target.value);
  };

  const handleLongitudeChange = (e) => {
    setLongitude(e.target.value);
  };

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;
    if (type === 'file') {
      if (files[0] && files[0].size > 2097152) {
        setAlertInfo({ show: true, message: "File size should be less than 2 MB!", severity: 'error' });
        const refs = {
          GST: GSTRef,
          panCard: panRef,
          adharCard: adharCardRef,
        };

        if (refs[name] && refs[name].current) {
          refs[name].current.value = "";
        }

        setFormData(prevState => ({
          ...prevState,
          [name]: null
        }));
        return;
      }
      setFormData(prevState => ({
        ...prevState,
        [name]: files[0]
      }));
    } else if (name === 'state') {
      setFormData(prevState => ({ ...prevState, [name]: value, district: '', pincode: '' }));
      loadCities(value);
    } else if (["vendorPhone", "contactPersonNum", "contactPersonNum2"].includes(name)) {
      let validValue = value.replace(/\D/g, '');
      if (validValue && validValue[0].match(/[6-9]/)) {
        validValue = validValue.slice(0, 10);
      } else {
        validValue = '';
      }

      setFormData({
        ...formData,
        [name]: validValue,
      });
    } else if (["pincode", "rate", "perHR"].includes(name)) {
      const validValue = value.replace(/\D/g, '').slice(0, 6);
      setFormData({
        ...formData,
        [name]: validValue,
      });
    } else if (name === "adharNo") {
      const validValue = value.replace(/\D/g, '').slice(0, 12);
      setFormData({
        ...formData,
        [name]: validValue,
      });
    } else if (name === "email") {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    else if (name === "district") {
      const changedValue = value
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");

      setFormData({
        ...formData,
        [name]: changedValue
      });
    }
    else if (name === "vendorType") {
      setFormData({
        ...formData,
        [name]: value,
      })
    }
    else {
      const capitalizedValue = value
        .split(' ')
        .map(word => word.toUpperCase())
        .join(' ');

      setFormData(prevState => ({
        ...prevState,
        [name]: capitalizedValue
      }));
    }
  };

  const validateForm = () => {
    for (const [key, value] of Object.entries(formData)) {
      if (["panCard", "adharCard"].includes(key)) {
        if (value === null || value === undefined || value.size === 0) {
          return `Field '${key}' is required.`;
        }
      }
      if ((key !== "remark" && key !== 'email' && key !== "GSTNo" && key !== "GST" && key !== "adharNo" && key !== "adharCard" && key !== "panNo" && key !== "panCard" && key !== "contactPersonNum2") && value === '') {
        return `Field '${key}' is required.`;
      }
    }

    if (formData.email !== "") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.email)) {
        return 'Please enter a valid email address.';
      }
    }

    const phoneRegex = /^[0-9]{10}$/
    if (!phoneRegex.test(formData.vendorPhone)) {
      return 'Please enter a valid Vendor Phone Number.';
    }
    if (!phoneRegex.test(formData.contactPersonNum)) {
      return 'Please enter a valid Contact Person Number.';
    }
    if (formData.contactPersonNum2 !== "" && !phoneRegex.test(formData.contactPersonNum2)) {
      return 'Please enter a valid Secondary Contact Person Number.';
    }

    const aadhaarRegex = /^\d{12}$/;
    if (formData.adharNo !== "" && !aadhaarRegex.test(formData.adharNo)) {
      return 'Please enter a valid Aadhaar Number.';
    }

    const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z])$/;
    if (formData.GSTNo !== "" && !gstRegex.test(formData.GSTNo)) {
      return 'Please enter a valid GST number (e.g., 22ABCDE1234F1Z5).';
    }

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (formData.panNo !== "" && !panRegex.test(formData.panNo)) {
      return 'Please enter a valid PAN number (e.g., ABCDE1234F).';
    }

    return '';
  };

  const validateInnerForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!recipientName) {
      formErrors.recipientName = 'Please enter recipient name';
      isValid = false;
    }

    if (paymentMethod === 'bank') {
      if (!bankDetails.bankName || !bankDetails.bankAccount || !bankDetails.ifscCode || !bankDetails.branchName) {
        formErrors.bankDetails = 'Please fill all bank details';
        isValid = false;
      }
      if (bankDetails.bankAccount && !/^\d{9,18}$/.test(bankDetails.bankAccount)) {
        formErrors.bankAccount = 'Please enter a valid bank account number';
        isValid = false;
      }
      if (bankDetails.ifscCode && !/^[A-Za-z]{4}[a-zA-Z0-9]{7}$/.test(bankDetails.ifscCode)) {
        formErrors.ifscCode = 'Please enter a valid IFSC code';
        isValid = false;
      }
    } else if (paymentMethod === 'upi') {
      if (!upiDetails.mobileNumber || !upiDetails.upiId) {
        formErrors.upiDetails = 'Please fill both mobile number and UPI ID';
        isValid = false;
      }
      if (upiDetails.mobileNumber && !/^\d{10}$/.test(upiDetails.mobileNumber)) {
        formErrors.mobileNumber = 'Please enter a valid mobile number';
        isValid = false;
      }
      if (upiDetails.upiId && !/^[\w.-]+@[\w.-]+$/.test(upiDetails.upiId)) {
        formErrors.upiId = 'Please enter a valid UPI ID';
        isValid = false;
      }
    } else {
      formErrors.paymentMethod = 'Please select a payment method';
      isValid = false;
    }

    setErrors(formErrors);
    return isValid ? '' : formErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!e.target.checkValidity()) {
      e.target.reportValidity();
      setIsLoading(false);
      return;
    }

    const validationMessage = validateForm();
    if (validationMessage) {
      setAlertInfo({ show: true, message: validationMessage, severity: 'error' });
      setIsLoading(false);
      return;
    }

    if (latitude === "" || longitude === "" || location === "Geolocation is not supported by this browser.") {
      setAlertInfo({ show: true, message: "Please Give latitude and Longitude", severity: 'error' });
      setIsLoading(false);
      return;
    }

    let sendData = {};

    if (paymentMethod === 'bank') {
      sendData = {
        recipientName,
        ...bankDetails
      };
    } else if (paymentMethod === 'upi') {
      sendData = {
        recipientName,
        ...upiDetails
      };
    }

    const formDataObj = new FormData();
    for (const key in formData) {
      if (formData[key]) {
        if (formData[key] instanceof File) {
          formDataObj.append(key, formData[key], formData[key].name);
        } else {
          formDataObj.append(key, formData[key]);
        }
      }
    }

    for (const key in sendData) {
      if (sendData[key]) formDataObj.append(key, sendData[key]);
    }

    formDataObj.append('latitude', latitude);
    formDataObj.append('longitude', longitude);

    try {
      const response = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/venderInfo/${userId}`,
        data: formDataObj,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setIsLoading(false);
      setAlertInfo({ show: true, message: response.data.message, severity: 'success' });

      setFormData({});
      sendData = {};
      setLatitude("");
      setLongitude("");

    } catch (error) {
      setIsLoading(false);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      if (errorMessage === "jwt expired") {
        setAlertInfo({ show: true, message: "Your session has expired. Redirecting to login...", severity: 'error' });
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      } else {
        setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
      }
    }
  }

  // Reads the chosen excel client-side (no upload) to show headers, row count,
  // and a few sample rows so the user can sanity-check the file before sending
  // potentially 1000+ rows to the server.
  const buildExcelPreview = (file) => {
    setExcelPreviewError('');
    setExcelPreview(null);
    setImportResult(null);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[firstSheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });

        if (rows.length === 0) {
          setExcelPreviewError('This excel file has no data rows.');
          return;
        }

        const headers = Object.keys(rows[0]);
        const missingColumns = EXPECTED_EXCEL_COLUMNS.filter(col => !headers.includes(col));

        setExcelPreview({
          headers,
          rows: rows.slice(0, 5),
          totalRows: rows.length,
          missingColumns
        });
      } catch (err) {
        console.error('Error parsing excel for preview:', err);
        setExcelPreviewError("Couldn't read this file. Make sure it's a valid .xlsx/.xls file.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleExcelSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setImportResult(null);
    const formDataObj = new FormData();
    for (const key in otherFormData) {
      if (otherFormData[key]) {
        formDataObj.append(key, otherFormData[key], otherFormData[key].name);
      }
    }

    try {
      const response = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/venderInfo/${userId}`,
        data: formDataObj,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setIsLoading(false);
      setImportResult(response.data);
      setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
    } catch (error) {
      setIsLoading(false);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      if (errorMessage === "jwt expired") {
        setAlertInfo({ show: true, message: "Your session has expired. Redirecting to login...", severity: 'error' });
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      } else {
        setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
      }
    }
  }

  const [showDropdown, setShowDropdown] = useState(false);
  const handleSelect = (event, value) => {
    event.preventDefault();
    setFormData({
      ...formData,
      vendorType: value
    });
    setShowDropdown(false);
  };
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const bankFormOpen = () => setShowBankForm(!showBankForm);
  const toggleZoom = () => setIsZoomed(!isZoomed);
  const toggleZoom1 = () => setIsZoomed1(!isZoomed1);

  const handleExcelChange = (e) => {
    const { name, files } = e.target;
    if (name === 'vendorsInfo') {
      const file = files[0];
      if (!file) return;

      if (file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        setAlertInfo({ show: true, message: "should be only excel file!!!", severity: 'error' });
        const refs = {
          vendorsInfo: vendorsInfoRef
        }
        if (refs[name] && refs[name].current) {
          refs[name].current.value = "";
        }
        setOtherFormData(prevState => ({
          ...prevState,
          [name]: ''
        }));
        setExcelPreview(null);
        setExcelPreviewError('');
        return;
      }

      setOtherFormData(prevState => ({
        ...prevState,
        [name]: file
      }));
      buildExcelPreview(file);
    }
  };

  return (
    <div >
      <Admin />
      <Helmet>
        <title>Vendor Details - Claimpro</title>
        <meta name="description" content="Vendor for ClaimPro Assist and for vehicle accidents. Keep track of Vendors." />
        <meta name="keywords" content="Vehicle Accidents, vendor, vendor Information, accident trucks,  Customer Service, Claimpro, Claim pro Assist, Claimpro Assist ,Accidental repair ,Motor Insurance claim,Advocate services ,Crane service ,On site repair,Accident Management" />
        <link rel='canonical' href={`https://claimpro.in/VendorMaster`} />
      </Helmet>

      {/* Mode switcher: single vendor vs bulk excel upload. Lives outside both forms
          so it's visible and functional regardless of which mode is active. */}
      <div
        className='switchparent-container'
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', padding: '14px 20px',paddingTop: '20px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}
      >
        <span style={{ fontSize: '14px', fontWeight: singleVendor ? 'bold' : 'normal', color: singleVendor ? '#21A6E9' : '#888' }}>
          Add Single Vendor
        </span>
        <Android12Switch
          checked={singleVendor}
          onChange={handleSwitchChange}
        />
        <span style={{ fontSize: '14px', fontWeight: !singleVendor ? 'bold' : 'normal', color: !singleVendor ? '#21A6E9' : '#888' }}>
          Bulk Upload (Excel)
        </span>
      </div>

      {!singleVendor && (
        <form onSubmit={handleExcelSubmit} style={{ background: "#f1f1f1", }} className="vendor-master-form">
          <div>
            <div class="header-container">
              <h3 class="bigtitle">Vendor Excel File</h3>
              <span class="mandatory-note">All fields are mandatory</span>
            </div>
            <div className='form-row'>
              <label className="form-field">
                Vendors Data : (only Excel files should be inserted)
                <input
                  type='file'
                  name="vendorsInfo"
                  ref={vendorsInfoRef}
                  onChange={handleExcelChange}
                  className="form-control"
                  required />
              </label>
              <label className="form-field">
                <IconButton href={vendorsInfo} download="vendorsInfo.xlsx" color="primary">
                  <p style={{ fontSize: "12px" }}>Download Reference Excel File</p>
                  <DownloadIcon />
                </IconButton>
              </label>

              <div style={{ border: "2px solid lightblue", padding: "20px", borderRadius: "10px" }}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>have a look how structure looks :</p>
                <div className={isZoomed ? "overlay" : ""}>
                  <label className="form-field" onClick={toggleZoom}>
                    <img
                      src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vendorInfo1.jpg'
                      alt="Dashboard Icon"
                      style={{
                        height: isZoomed ? '90%' : '35px',
                        width: isZoomed ? '90%' : '90%',
                        marginRight: '8px',
                        marginLeft: "8px",
                        transition: 'transform 0.3s ease',
                        cursor: 'pointer'
                      }}
                    />
                  </label>
                </div>

                <div className={isZoomed1 ? 'overlay' : ''}>
                  <label className="form-field" onClick={toggleZoom1}>
                    <img
                      src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vendorInfo2.jpg'
                      alt="Dashboard Icon"
                      style={{
                        height: isZoomed ? '90%' : '35px',
                        width: isZoomed ? '90%' : '90%',
                        marginRight: '8px',
                        marginLeft: "8px",
                        transition: 'transform 0.3s ease',
                        cursor: 'pointer'
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* --- Excel preview: shown as soon as a file is chosen, before submit --- */}
            {excelPreviewError && (
              <div style={{ margin: '20px' }}>
                <Alert severity="error">{excelPreviewError}</Alert>
              </div>
            )}

            {excelPreview && (
              <div style={{ margin: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '8px', background: '#fff' }}>
                <p style={{ marginBottom: '8px' }}>
                  <strong>{excelPreview.totalRows}</strong> rows detected. Showing first {excelPreview.rows.length}:
                </p>

                {excelPreview.missingColumns.length > 0 && (
                  <Alert severity="warning" style={{ marginBottom: '10px' }}>
                    These expected columns weren't found in your file: <strong>{excelPreview.missingColumns.join(', ')}</strong>.
                    Rows missing required fields will be skipped on import.
                  </Alert>
                )}

                <div style={{ overflowX: 'auto', maxHeight: '260px' }}>
                  <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        {excelPreview.headers.map(h => (
                          <th key={h} style={{ textAlign: 'left', padding: '6px', borderBottom: '1px solid #ddd', whiteSpace: 'nowrap' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {excelPreview.rows.map((row, i) => (
                        <tr key={i}>
                          {excelPreview.headers.map(h => (
                            <td key={h} style={{ padding: '6px', borderBottom: '1px solid #f1f1f1', whiteSpace: 'nowrap' }}>{String(row[h] ?? '')}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          {alertInfo.show && (
            <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
              {alertInfo.message}
            </Alert>
          )}

          {/* --- Import results: shown after submit completes --- */}
          {importResult && (
            <div style={{ margin: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '8px' }}>
              <p><strong>{importResult.successCount}</strong> vendors imported successfully.</p>
              {importResult.failureCount > 0 && (
                <>
                  <p style={{ color: '#b45309' }}><strong>{importResult.failureCount}</strong> rows skipped:</p>
                  <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', fontSize: '13px' }}>
                      <thead>
                        <tr><th>Row</th><th>Vendor</th><th>Reason</th></tr>
                      </thead>
                      <tbody>
                        {importResult.failures.map((f, i) => (
                          <tr key={i}>
                            <td>{f.row}</td>
                            <td>{f.vendorName}</td>
                            <td>{f.type === 'validation' ? `Missing: ${(f.missing || []).join(', ')}` : f.reason}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          )}

          <div style={{ textAlign: 'center', margin: '30px' }}>
            <button type="submit"
              style={{
                fontSize: "14px",
                padding: "5px 20px",
                border: "3px solid lightblue",
                borderRadius: "4px",
                cursor: "pointer",
                backgroundColor: "transparent",
                color: "green",
              }}
              disabled={isLoading || !!excelPreviewError}
            >
              {isLoading ? 'Submitting...' : 'Submit'}
            </button>
            {isLoading && (
              <div style={{ marginTop: '10px' }}>
                <ClipLoader color="#4CAF50" loading={isLoading} />
                <div style={{ marginTop: '10px', color: '#4CAF50' }}>Importing vendors, this can take a minute for large files...</div>
              </div>
            )}
          </div>
        </form>
      )}

      {singleVendor && (
        <form onSubmit={handleSubmit} style={{ marginTop: "-20px" }}>

          <form className='Customer-master-form' style={{ marginBottom: "40px", }}>
            <div class="header-container">
              <h3 class="bigtitle" style={{ marginTop: "-10px" }}>Vendor Master</h3>
              <span class="mandatory-note">* All fields are mandatory</span>
            </div>

            <div className="form-row">
              <label className="form-field input-group mb-3">
                System Date:
                <input
                  type="date"
                  name="systemDate"
                  value={formData.systemDate}
                  onChange={handleChange}
                  readOnly
                  className="form-control"
                />
              </label>

              <label className="form-field input-group mb-3">
                Vendor Code:
                <input
                  type="text"
                  name="vendorCode"
                  placeholder='SYSTEM GENERATED'
                  value={formData.vendorCode}
                  className="form-control"
                  readOnly
                />
              </label>
              <label className="form-field input-group mb-3">
                Vendor Place -State:
                <select
                  name="state"
                  onChange={handleChange}
                  disabled={isLoadingStates}
                  value={formData.state}>
                  <option value="">Select State</option>
                  {states.map(state => (
                    <option key={state.isoCode} value={state.isoCode}>{state.name}</option>
                  ))}
                </select>
              </label>

              {!toInputBox && (
                <label className="form-field input-group mb-3">
                  <div className='switchparent-container' style={{ display: 'flex', alignItems: 'center', height: "18px" }}>
                    <span style={{ marginRight: '10px' }}>Vendor Place - City:</span>
                    <div className="switch-container">
                      <FormControlLabel
                        control={<Android12Switch defaultChecked />}
                        checked={toInputBox}
                        onChange={handleSwitchInputBox}
                        label=""
                      />
                    </div>
                  </div>

                  <select
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    disabled={isLoadingCities || !formData.state}
                  >
                    <option value="">Select City</option>
                    {!cities.error && cities.map(city => (
                      <option key={city.name} value={city.name}>{city.name}</option>
                    ))}
                  </select>
                </label>
              )}

              {toInputBox && (
                <label className="form-field input-group mb-3">
                  <div className='switchparent-container' style={{ display: 'flex', alignItems: 'center', height: "18px" }}>
                    <span style={{ marginRight: '10px' }}>Vendor Place - City:</span>
                    <div className="switch-container">
                      <FormControlLabel
                        control={<Android12Switch defaultChecked />}
                        checked={toInputBox}
                        onChange={handleSwitchInputBox}
                        label=""
                      />
                    </div>
                  </div>
                  <input
                    type="text"
                    name="district"
                    placeholder='District'
                    value={formData.district}
                    onChange={handleChange}
                    className="form-control"
                    readOnly={formData.state === ""}
                    required
                  />
                </label>
              )}

            </div>

            <div className='form-row'>

              <label className="form-field input-group mb-3">
                Vendor Name:
                <input
                  type="text"
                  name="vendorName"
                  placeholder='Vendor Name'
                  value={formData.vendorName}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </label>

              <div className="dropdown green-dropdown form-field">
                Select Vendor Type:
                <button
                  className="form-field input-group mb-3 mt-2"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={toggleDropdown}
                >
                  {formData.vendorType || "Select Vendor Type"}
                </button>
                <ul className={`dropdown-menu${showDropdown ? " show" : ""}`} aria-labelledby="dropdownMenuButton">
                  <li><a className="dropdown-item" href="#" onClick={(e) => handleSelect(e, "advocate")}>Advocate</a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => handleSelect(e, "crane")}>Crane</a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => handleSelect(e, "mechanic")}>Mechanic</a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => handleSelect(e, "workshop")}>Workshop</a></li>
                </ul>
              </div>
              <label className="form-field">
                Address  :
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  className="form-control"
                  placeholder='Address' />
              </label>
              <label className="form-field">
                Pincode:
                <input
                  type='tel'
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder='Pincode'
                  required
                  pattern="\d{6}"
                  title="Pincode must be 6 digits"
                  className="form-control"
                />
              </label>
            </div>

            <div className='form-row'>

              <label className="form-field">
                Vendor Phone No:
                <input
                  type='tel'
                  name="vendorPhone"
                  value={formData.vendorPhone}
                  onChange={handleChange}
                  placeholder='Vendor Phone No'
                  required
                  pattern="\d{10}"
                  title="Phone number must be exactly 10 digits"
                  className="form-control"
                />
              </label>

              <label className="form-field">
                E-Mail:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder='E-Mail'
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  title="Please enter a valid email address."
                  className="form-control"
                />
              </label>

              <label className="form-field">
                Contact Person:
                <input
                  type='text'
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  placeholder='Contact Person Name'
                  className="form-control"

                  required />
              </label>
              <label className="form-field">
                Contact Person Number:
                <input
                  type='tel'
                  name="contactPersonNum"
                  value={formData.contactPersonNum}
                  onChange={handleChange}
                  placeholder='Contact Person Phone'
                  required
                  pattern="\d{10}"
                  className="form-control"
                  title="Phone number must be 10 digits" />
              </label>
            </div>

            <div className='form-row'>
              <label className="form-field">
                Contact Person Number 2 :
                <input
                  type='tel'
                  name="contactPersonNum2"
                  value={formData.contactPersonNum2}
                  placeholder='Contact Person Phone'
                  onChange={handleChange}
                  pattern="\d{10}"
                  title="Phone number must be 10 digits"
                  className="form-control"

                />
              </label>
              <label className="form-field">
                PAN Number:
                <input
                  type='text'
                  name="panNo"
                  placeholder='Pan Card Number'
                  value={formData.panNo}
                  onChange={handleChange}
                  className="form-control"
                  pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                  title="Please enter a valid PAN number (e.g., ABCDE1234F)."
                />
              </label>
              <label className="form-field">
                PAN Card :
                <input
                  type='file'
                  name="panCard"
                  onChange={handleChange}
                  accept="image/*"
                  className="form-control"
                  ref={panRef}
                  capture="environment"
                />
              </label>
              <label className="form-field">
                Aadhaar Number:
                <input
                  type='text'
                  name="adharNo"
                  placeholder='Aadhaar Card Number'
                  value={formData.adharNo}
                  onChange={handleChange}
                  className="form-control"
                  pattern="\d{12}"
                  title="Aadhaar number must be exactly 12 digits."
                />
              </label>
            </div>

            <div className='form-row'>
              <label className="form-field">
                Adhar Card:
                <input
                  type='file'
                  name="adharCard"
                  onChange={handleChange}
                  accept="image/*"
                  ref={adharCardRef}
                  className="form-control"
                  capture="environment"
                />
              </label>

              <label className="form-field">
                GST Number:
                <input
                  type='text'
                  name="GSTNo"
                  placeholder='GST Number'
                  value={formData.GSTNo}
                  onChange={handleChange}
                  className="form-control"
                  pattern="^([0-9]{2})([A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1})$"
                  title="Please enter a valid GST number (e.g., 22ABCDE1234F1Z5)."
                />
              </label>

              <label className="form-field">
                GSTIN :
                <input
                  type='file'
                  name="GST"
                  onChange={handleChange}
                  accept="image/*"
                  ref={GSTRef}
                  capture="environment"
                  className="form-control"
                />
              </label>

              <label className="form-field">
                Remark :
                <textarea
                  name="remark"
                  value={formData.remark}
                  onChange={handleChange}
                  className="form-control"
                  placeholder='Remark' />
              </label>
            </div>

            <div>
              {formData.vendorType === "crane" &&
                (
                  <div className='form-row'>
                    <label className="form-field">
                      Rate/KM :
                      <input
                        type='text'
                        name="rate"
                        placeholder='Rate Per KM'
                        value={formData.rate}
                        onChange={handleChange}
                        className="form-control"
                        title="Aadhaar number must be exactly 12 digits."
                        required />
                    </label>

                    <label className="form-field">
                      per HR:
                      <input
                        type='text'
                        name="perHR"
                        placeholder='Rate Per HR'
                        value={formData.perHR}
                        onChange={handleChange}
                        className="form-control"
                        title="Aadhaar number must be exactly 12 digits."
                        required />
                    </label>
                    <label className="form-field"></label>
                    <label className="form-field"></label>
                  </div>
                )}
              {formData.vendorType != "crane" && (
                <label className="form-field"></label>
              )}
            </div>

          </form>

          <form className='Customer-master-form' style={{ marginBottom: "40px" }}>
            <h1 style={{ fontWeight: 'bold', fontSize: "25px", marginBottom: "20px" }}>Location</h1>
            <p>   Send Your Current Location (if it's same for filling address):</p>
            <div className='form-row'>
              <Button variant="contained" onClick={getLocation}>Send Location</Button>
            </div>

            <p>   Send Location Of Address (this is by your address):</p>
            <div className='form-row'>
              <label className='form-field'>
                Latitude:
                <input type="text" value={latitude} onChange={handleLatitudeChange} />
              </label>
              <label className='form-field'>
                Longitude:
                <input type="text" value={longitude} onChange={handleLongitudeChange} />
              </label>
              <label className='form-field'></label>
            </div>
            {location && (location.startsWith("Error:") ? <Alert severity="error">{location}</Alert> : <Alert severity="success">{location}</Alert>)}
          </form>

          <form className="Customer-master-form" style={{ background: "#c4c4ff3d", marginBottom: "30px", boxShadow: "0 8px 16px rgba(0, 0, 0, 0.4), inset 0 0 10px rgba(255, 255, 255, 0.2)", borderRadius: "30px" }}>
            <div class="header-container">
              <h3 class="bigtitle">Bank Information</h3>
            </div>
            <div className="form-row">
              <label className="form-field input-group mb-3">
                Recipient's Name:
                <input
                  type="text"
                  name="recipientName"
                  value={recipientName}
                  onChange={(e) => {
                    const capitalizedValue = e.target.value.split(' ').map(word => word.toUpperCase()).join(' ');
                    setRecipientName(capitalizedValue);
                  }}
                  className="form-control"
                />
                {errors.recipientName && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.recipientName}</p>}
              </label>
            </div>

            <div className="form-row" style={{ display: 'flex', gap: '10px' }}>
              <button
                type="button"
                onClick={() => setPaymentMethod('bank')}
                disabled={!recipientName}
                style={{ flex: 1 }}
              >
                Bank Transfer
              </button>
              <button
                type="button"
                onClick={() => setPaymentMethod('upi')}
                disabled={!recipientName}
                style={{ flex: 1 }}
              >
                UPI
              </button>
            </div>
            {errors.paymentMethod && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.paymentMethod}</p>}

            {paymentMethod === 'bank' && (
              <div className="Customer-master-form" style={{ marginLeft: "0px", marginRight: "0px", paddingLeft: '15px', paddingRight: "25px" }}>
                <label className="form-field input-group mb-3">
                  Bank Name:
                  <input
                    type="text"
                    name="bankName"
                    value={bankDetails.bankName}
                    onChange={handleBankDetailsChange}
                    className="form-control"
                  />
                </label>
                <label className="form-field input-group mb-3">
                  Bank Account:
                  <input
                    type="text"
                    name="bankAccount"
                    value={bankDetails.bankAccount}
                    onChange={handleBankDetailsChange}
                    className="form-control"
                  />
                  {errors.bankAccount && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.bankAccount}</p>}
                </label>
                <label className="form-field input-group mb-3">
                  IFSC Code:
                  <input
                    type="text"
                    name="ifscCode"
                    value={bankDetails.ifscCode}
                    onChange={handleBankDetailsChange}
                    className="form-control"
                  />
                  {errors.ifscCode && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.ifscCode}</p>}
                </label>
                <label className="form-field input-group mb-3">
                  Branch Name:
                  <input
                    type="text"
                    name="branchName"
                    value={bankDetails.branchName}
                    onChange={handleBankDetailsChange}
                    className="form-control"
                  />
                </label>
                {errors.bankDetails && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.bankDetails}</p>}
              </div>
            )}

            {paymentMethod === 'upi' && (
              <div className="Customer-master-form" style={{ marginLeft: "0px", marginRight: "0px", paddingLeft: '15px', paddingRight: "25px" }}>
                <label className="form-field input-group mb-3">
                  Registered Mobile Number:
                  <input
                    type="text"
                    name="mobileNumber"
                    value={upiDetails.mobileNumber}
                    onChange={handleUpiDetailsChange}
                    className="form-control"
                  />
                  {errors.mobileNumber && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.mobileNumber}</p>}
                </label>
                <label className="form-field input-group mb-3">
                  UPI ID:
                  <input
                    type="text"
                    name="upiId"
                    value={upiDetails.upiId}
                    onChange={handleUpiDetailsChange}
                    className="form-control"
                  />
                  {errors.upiId && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.upiId}</p>}
                </label>
                {errors.upiDetails && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>{errors.upiDetails}</p>}
              </div>
            )}
          </form>

          {alertInfo.show && (
            <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
              {typeof alertInfo.message === 'string' ? alertInfo.message : JSON.stringify(alertInfo.message)}
            </Alert>
          )}

          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <button type="submit"
              style={{
                fontSize: "14px",
                padding: "5px 20px",
                border: "3px solid lightblue",
                borderRadius: "4px",
                cursor: "pointer",
                backgroundColor: "transparent",
                color: "green",
                marginBottom: "40px"
              }}
              disabled={isLoading}
            >
              {isLoading ? 'Submitting...' : 'Submit'}
            </button>
            {isLoading && (
              <div style={{ marginTop: '10px' }}>
                <ClipLoader color="#4CAF50" loading={isLoading} />
                <div style={{ marginTop: '10px', color: '#4CAF50' }}>Submitting your form, please wait...</div>
              </div>
            )}
          </div>
        </form>
      )}
    </div>
  );
};

export default VendorMasterForm;